<template>
	<tr>
		<td class="text-center p-2" :style="{'width': '40px'}">
			<a-avatar :src="images().deal(data,100)" :size="40" shape="square" />
		</td>
		<td class="align-middle" :style="{'max-width': '400px','height': '40px'}">
			<h5 class="text-overflow pointer" @click="$router.push({name: 'postEdit', params: {id: data.id}})">
				{{ data.name }}
			</h5>
		</td>
		<td class="align-middle" :style="{'min-width': '200px'}">
			<div class="row">
				<div class="col-6">
					<a-tooltip>
						<template #title>
							<span>Precio Antes</span>
						</template>
						<a-button v-if="data.old_price" type="primary" block :style="{'background-color': $colors['gray-6'], 'border-color': $colors['gray-6']}" class="font-size-18 font-weight-bold text-strike">
							{{ oldPrice[0] + ' ' + oldPrice[1] }}
						</a-button>
					</a-tooltip>
				</div>
				<div class="col-6">
					<a-tooltip>
						<template #title>
							<span>Precio Ahora</span>
						</template>
						<a-button v-if="data.sale_price" type="primary" block :style="{'background-color': $colors.success, 'border-color': $colors.success}" class="font-size-18 font-weight-bold">
							{{ salePrice[0] + ' ' + salePrice[1] }}
						</a-button>
					</a-tooltip>
				</div>
			</div>
		</td>
		<td class="align-middle text-center">
			<template v-if="data.store">
				<img v-if="data.store[0].image_url" :src="data.store[0].image_url" :alt="data.store[0].name" :style="{height: '40px'}" loading="lazy">
				<span v-else>
					{{ data.store[0].name }}
				</span>
			</template>
		</td>
		<td class="text-center align-middle" :style="{'width': '40px'}">
			<user-avatar :user="data.user" :size="40" />
		</td>
		<td class="align-middle" :style="{'min-width': '150px'}">
			<deal-status :value="data.status" class="mr-4" :options="['active', 'expired', 'draft', 'disabled']" @input="setStatus" />
		</td>
		<td class="align-middle" :style="{'min-width': '130px'}">
			<a-tooltip placement="top">
				<template #title>
					<span>{{ $moment(data.created_at).format('LLL') }}</span>
				</template>
				<!--<b v-if="$moment().diff(data.created_at) > 0" class="text-uppercase text-muted mr-auto">{{ $moment(data.created_at).fromNow() }}</b>
				<b v-else class="text-uppercase text-danger mr-auto"><fa-icon :icon="['far','alarm-clock']" class="mr-2 animated pulse delay-1s infinite" />{{ $moment(data.created_at).fromNow() }}<span class="date-real">( {{ $moment(data.created_at).format('DD-MM HH:mm') }} )</span></b>-->
				<b v-if="$moment().diff(data.created_at) > 0" class="text-uppercase text-muted mr-auto">{{ $moment(data.created_at).fromNow() }}</b>
				<b v-else class="text-uppercase text-danger mr-auto"><fa-icon :icon="['far','alarm-clock']" class="mr-2 animated pulse delay-1s infinite" />{{ $moment(data.created_at).fromNow() }} <span class="date-real">( {{ $moment(data.created_at).format('DD-MM HH:mm') }} )</span></b>
			</a-tooltip>
		</td>
		<td class="text-right align-middle" :style="{'min-width': '90px'}">
			<a-button size="small" @click="$router.push({name: 'postEdit', params: {id: data.id}})">
				<fa-icon :icon="['fal','edit']" class="mr-2" /> Editar
			</a-button>
		</td>
	</tr>
</template>

<script>
export default {
	props: {
		data: {
			type: Object,
			required: true,
		},
		user: {
			type: [Object, Boolean],
			default: null,
		},
	},
	computed: {
		author() {
			if (this.user) {
				return this.user;
			} if (this.data.user) {
				return this.data.user;
			}

			return null;
		},
		popularity() {
			return this.parser().popularity(this.data.popularity);
		},
		salePrice() {
			if (this.data.sale_price) {
				return [this.data.sale_price, '€'];
			} if (this.data.sale_price === 0) {
				return ['GRATIS', ''];
			}

			return ['...', ''];
		},
		oldPrice() {
			if (this.data.old_price) {
				return [this.data.old_price, '€'];
			} if (this.data.old_price === 0) {
				return ['GRATIS', ''];
			}

			return ['', ''];
		},
		status() {
			return this.parser().dealStatus(this.data.status);
		},
	},
	methods: {
		async setStatus(status) {
			const edit = await this.$sdk.deals().edit(this.data.id, { status });

			if (edit.ok) {
				// await this.$root.wordpress().status(this.data, status);

				this.$store.dispatch('setItem', { id: this.data.id, data: { ...this.data, status }, type: 'posts' });
				this.$store.dispatch('setItem', { id: this.data.id, data: { ...this.data, status }, type: 'pendingPosts' });

				this.$message.success('Se modifico el estado del post correctamente');
			}
		},
	},
};
</script>

<style lang="scss" scoped>
	.date-real{
		color: #ff8200;
	}
</style>
